/**
 * Valdiation form custom element enables and fixes bootstraps validation styling.
 * jQuery validate and validate unobtrusive handles the actual validation logic.
 */
export default class ValidationForm extends HTMLFormElement {

    connectedCallback() {
        this.initForm();
        this.addEventListener('submit', this.validateForm, false);
    }

    disconnectedCallback() {

        this.removeEventListener('submit', this.validateForm);

    }

    initForm() {
        if (!this.classList.contains("needs-validation"))
            this.classList.add("needs-validation");

        // Add pattern attribute if missing
        this.querySelectorAll("[data-val-regex-pattern]").forEach(el => {

            if (el.hasAttribute("pattern"))
                return;

            el.setAttribute("pattern", el.getAttribute("data-val-regex-pattern"));
        });
    }

    validateForm = (e) => {
        if (!this.checkValidity()) {
            this.classList.add("was-validated");

            this.scrollIntoView(true);

            window.setTimeout(() => {
                this.validationSummary.focus();
            }, 1000);
        }

    }

    get validationSummary() {
        return this.querySelector("[data-valmsg-summary]");
    }
}

customElements.define('validation-form', ValidationForm, { extends: 'form' });